<script setup lang="ts">
import { RouterLink, type RouterLinkProps } from 'vue-router';
import {computed} from 'vue'

const props = defineProps<RouterLinkProps>();

const isExternal = computed(() => {
  return typeof props.to === 'string' &&
    (props.to && (props.to.startsWith('http://') || props.to.startsWith('https://')));
});
</script>

<template>
  <a v-if="isExternal" :href="to" target="_blank" class="external-link"  rel="noopener noreferrer"><slot/></a>
  <router-link v-else v-bind="$props"><slot/></router-link>
</template>

<style scoped>

</style>
